import React from "react";
import {GridItem} from "../../../../../components/Grid";
import {Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, FormLabel, Typography} from "@mui/material";

const FilterCheckBox = props => {
  const {
    optionList,
    optionNameDisplay,
    onHandleChange,
    defaultValues,
    formLabelValue=null,
    formHelperValue = null,
    screenRatios = {xs: 12, sm: 12, md: 2, lg: 2},
    render
  } = props;

  if (render === false || (render === undefined && onHandleChange === undefined))
  {
    return null;
  }
  else return (
    <GridItem
      xs={screenRatios.xs}
      sm={screenRatios.sm}
      md={screenRatios.md}
      lg={screenRatios.lg}
      xl={screenRatios.xl}
    >
      <Typography variant="h5" gutterBottom>
        {optionNameDisplay}
      </Typography>

      <FormControl component="fieldset">
        {(formLabelValue != null) &&
          <FormLabel component="legend">{formLabelValue}</FormLabel>
        }
        <FormGroup>
          {optionList.map(m => (
            <FormControlLabel
              control={
                <Checkbox
                  name={m.name}
                  key={m.id}
                  id={m.id}
                  checked={defaultValues}
                  onChange={onHandleChange}
                />
              }
              label={m.label}
              labelPlacement="start"
            />
          ))}
        </FormGroup>
        {(formHelperValue != null) &&
          <FormHelperText>
            {formHelperValue}
          </FormHelperText>
        }
      </FormControl>
    </GridItem>
  );
}

export default FilterCheckBox;
